module.exports = __webpack_public_path__ + "img/tty-answer.740dff4a.svg";